export const SEO_DATA = {
  home: {
    title: "SwitchYourVendor | Vendor Management Platform in India",
    description: "Switch vendors easily across compliance, IT, manpower, and supplies. One-stop solution for businesses to manage vendors efficiently. Save up to 30% on costs.",
    keywords: "vendor management, vendor switching, compliance services India, IT services, manpower solutions, business supplies, vendor platform"
  },
  
  about: {
    title: "About Us - India's First Vendor Switching Platform",
    description: "Learn about SwitchYourVendor, India's first dedicated vendor switching platform helping SMEs find, compare, and switch to better service providers across compliance, IT, supplies, and manpower.",
    keywords: "about switchyourvendor, vendor platform India, SME solutions, business services"
  },
  
  partner: {
    title: "Partner With Us - Grow Your Business",
    description: "Partner with SwitchYourVendor and reach thousands of businesses looking for quality vendors. Join India's leading vendor management platform.",
    keywords: "vendor partnership, business partnership, service provider partnership India"
  },
  
  compliance: {
    title: "Compliance Services - Accounting, GST, Tax Filing",
    description: "Expert compliance services including accounting, GST filing, income tax, and MCA compliance. Certified CAs and accountants for hassle-free business compliance in India.",
    keywords: "compliance services India, GST filing, income tax filing, accounting services, MCA compliance, chartered accountant"
  },
  
  it: {
    title: "IT Services - Managed IT, Cybersecurity, Cloud Solutions",
    description: "Enterprise-grade IT services including managed IT, cybersecurity, cloud computing, and software development. 99.9% uptime SLA with 24/7 support.",
    keywords: "IT services India, managed IT services, cybersecurity solutions, cloud computing, IT consulting, software development"
  },
  
  supplies: {
    title: "Business Supplies - Office, Pantry, Corporate Gifts",
    description: "One-stop solution for all business supplies - office supplies, kitchen pantry, fresh fruits, branded apparel, and corporate gifts. Bulk discounts available.",
    keywords: "office supplies India, business supplies, corporate gifts, branded merchandise, pantry supplies"
  },
  
  manpower: {
    title: "Manpower Solutions - Staffing & HR Services",
    description: "Complete manpower solutions including permanent staffing, temporary staffing, payroll management, and executive search. Quick deployment across India.",
    keywords: "manpower solutions India, staffing services, recruitment services, payroll management, HR outsourcing"
  },
  
  privacyPolicy: {
    title: "Privacy Policy - Data Protection & Security",
    description: "Read our privacy policy to understand how SwitchYourVendor collects, uses, and protects your personal information and business data.",
    keywords: "privacy policy, data protection, GDPR compliance"
  },
  
  terms: {
    title: "Terms of Service - User Agreement",
    description: "Terms of service and user agreement for using SwitchYourVendor platform. Read our terms and conditions before using our services.",
    keywords: "terms of service, user agreement, terms and conditions"
  },
  
  refundPolicy: {
    title: "Refund Policy - Money Back Guarantee",
    description: "Understand our refund and cancellation policy. We offer transparent refund terms to ensure customer satisfaction.",
    keywords: "refund policy, cancellation policy, money back guarantee"
  }
};

// Individual service pages SEO
export const SERVICE_SEO = {
  // Compliance Services
  "compliance/accounting": {
    title: "Accounting Services - Expert Bookkeeping & Financial Statements",
    description: "Professional accounting services including bookkeeping, financial statements, and payroll processing. 99.8% accuracy with certified chartered accountants.",
    keywords: "accounting services India, bookkeeping services, financial statements, payroll processing"
  },
  "compliance/gst-filing": {
    title: "GST Filing Services - Hassle-free GST Compliance",
    description: "Expert GST filing services with 48-hour turnaround. Monthly/quarterly returns, GST registration, and input tax credit optimization.",
    keywords: "GST filing India, GST registration, GST returns, GST compliance services"
  },
  "compliance/income-tax": {
    title: "Income Tax Filing - Expert Tax Filing Services",
    description: "Complete income tax filing services for individuals and businesses. Expert tax planning, maximizing deductions, ensuring compliance.",
    keywords: "income tax filing India, ITR filing, tax planning, tax consultation"
  },
  "compliance/mca-compliance": {
    title: "MCA Compliance - Corporate Compliance Services",
    description: "Complete MCA compliance including annual filing, board resolutions, and statutory registers. Keep your business aligned with MCA regulations.",
    keywords: "MCA compliance India, corporate compliance, annual filing, ROC compliance"
  },
  
  // IT Services
  "it/managed-it": {
    title: "Managed IT Services - 24/7 IT Support & Management",
    description: "Comprehensive managed IT services with 99.9% uptime SLA. 24/7 monitoring, helpdesk support, and proactive maintenance.",
    keywords: "managed IT services India, IT support, IT management, helpdesk services"
  },
  "it/cybersecurity": {
    title: "Cybersecurity Solutions - Enterprise Security Services",
    description: "Advanced cybersecurity solutions including threat monitoring, vulnerability assessment, and incident response. Protect your business from cyber threats.",
    keywords: "cybersecurity India, cyber security services, threat protection, data security"
  },
  "it/cloud-computing": {
    title: "Cloud Computing Services - Migration & Management",
    description: "Cloud computing services including migration, management, and optimization. Multi-cloud support with 40% cost savings.",
    keywords: "cloud computing India, cloud migration, AWS services, Azure cloud, cloud management"
  },
  "it/it-consulting": {
    title: "IT Consulting Services - Strategic Technology Solutions",
    description: "Expert IT consulting for digital transformation, technology strategy, and IT infrastructure planning. Transform your business with technology.",
    keywords: "IT consulting India, technology consulting, digital transformation, IT strategy"
  },
  "it/software-development": {
    title: "Software Development - Custom Software Solutions",
    description: "Custom software development services for web, mobile, and enterprise applications. Agile development with scalable solutions.",
    keywords: "software development India, custom software, web development, mobile app development"
  },
  
  // Supplies
  "supplies/office-supplies": {
    title: "Office Supplies - Stationery & Office Essentials",
    description: "Complete range of office supplies including stationery, printing supplies, and office essentials. Bulk discounts and quick delivery.",
    keywords: "office supplies India, stationery supplies, office essentials, bulk office supplies"
  },
  "supplies/fresh-fruits": {
    title: "Fresh Fruits Supply - Office Pantry Fruits",
    description: "Fresh seasonal fruits delivered to your office. Healthy snacking options for employees. Regular delivery schedules available.",
    keywords: "fresh fruits delivery, office fruits, pantry fruits, fruit supply India"
  },
  "supplies/corporate-gifts": {
    title: "Corporate Gifts - Branded Merchandise & Gifts",
    description: "Premium corporate gifts and branded merchandise for clients and employees. Customization available with bulk pricing.",
    keywords: "corporate gifts India, branded merchandise, business gifts, promotional products"
  },
  "supplies/branded-apparel": {
    title: "Branded Apparel - Custom Corporate Clothing",
    description: "Custom branded apparel including t-shirts, uniforms, and corporate wear. Quality fabric with professional branding.",
    keywords: "branded apparel India, corporate clothing, custom t-shirts, uniform services"
  },
  
  // Manpower
  "manpower/permanent-staffing": {
    title: "Permanent Staffing Solutions - Recruitment Services",
    description: "Permanent staffing solutions for all levels. Find the right talent with our comprehensive recruitment services across India.",
    keywords: "permanent staffing India, recruitment services, hiring solutions, talent acquisition"
  },
  "manpower/payroll-management": {
    title: "Payroll Management Services - HR Outsourcing",
    description: "Complete payroll management services including salary processing, compliance, and statutory filings. Accurate and timely payroll processing.",
    keywords: "payroll management India, payroll services, payroll outsourcing, salary processing"
  },
  "manpower/facility-management": {
    title: "Facility Management Services - Housekeeping & Maintenance",
    description: "Professional facility management services including housekeeping, maintenance, and security. Keep your premises clean and safe.",
    keywords: "facility management India, housekeeping services, maintenance services, facility services"
  },
  "manpower/executive-search": {
    title: "Executive Search - Leadership Recruitment",
    description: "Executive search services for C-level and senior management positions. Find top leadership talent for your organization.",
    keywords: "executive search India, leadership recruitment, C-level hiring, headhunting services"
  }
};
